<template>
  <div class="container" style="padding: 10px">
    <div class="content mt20">
      <el-row class="e-box">
        <el-col :span="6" class="e-co">
          <el-row
            type="flex"
            justify="space-between"
            style="vertical-align: middle"
          >
            <el-col class="text_s">
              <span>角色名称</span>
            </el-col>
            <el-col class="middle-add text_r">
              <el-button
                type="primary"
                class="el-icon-circle-plus"
                @click="addRole"
                >添加角色</el-button
              >
            </el-col>
          </el-row>
          <el-alert
            class="mt10"
            title="双击角色可编辑"
            type="warning"
          ></el-alert>
          <el-menu default-active="1" class="mt20" @select="roleSelect">
            <el-menu-item
              v-for="(item, index) in rolesList"
              :key="index"
              :index="item.roleId"
              @mouseenter.native="selectStyle(item)"
              @mouseleave.native="outStyle(item)"
              @dblclick.native="editRole(item)"
            >
              <span>{{ item.roleName }}</span>
              <!--管理员不可删除-->
              <span v-if="item.roleId != 1 && item.isShowDelete">
                <a
                  href="javascript:void(0)"
                  @click="delRole(item.roleId)"
                  title="删除"
                >
                  <i class="el-icon-delete" />
                </a>
              </span>
              <span v-if="index > 0 && item.isShowDelete">
                <a
                  href="javascript:void(0)"
                  @click="changeOrder(item.roleId, 0)"
                  title="上移"
                >
                  <i class="el-icon-top" />
                </a>
              </span>
              <span v-if="index != rolesList.length - 1 && item.isShowDelete">
                <a
                  href="javascript:void(0)"
                  @click="changeOrder(item.roleId, 1)"
                  title="下移"
                >
                  <i class="el-icon-bottom" />
                </a>
              </span>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="18">
          <span class="text_s pl20">自定义</span>
          <div class="mt10 pl20 checked-box">
            <el-button
              type="primary"
              @click="saveChange"
              v-if="isShowButton"
              :loading="saveChangeLoading"
              >保存</el-button
            >
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="用户组成员" name="first">
                <div class="search-box">
                  <el-input
                    placeholder="搜索用户"
                    class="input-with-select"
                    size="medium"
                    v-model="keyword"
                    @keyup.enter.native="searchTo()"
                  >
                    <el-button
                      @click="searchTo()"
                      slot="append"
                      icon="el-icon-search"
                      title="搜索"
                    ></el-button>
                  </el-input>
                </div>
                <pagination-table
                  ref="table"
                  :data="customerList"
                  :columns="columns"
                  :loader="fetchRoleCustomer"
                  :async="true"
                  :pageSizes="[20]"
                  :style="{ width: '70%' }"
                ></pagination-table>
              </el-tab-pane>
              <el-tab-pane label="权限配置" name="second">
                <el-table :data="authority" v-loading="roleTableLoading">
                  <el-table-column label="操作对象" prop="groupName">
                    <template slot-scope="scope">
                      <span>{{ scope.row.groupName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="权限" prop="functionList" width="600">
                    <template slot-scope="scope">
                      <el-checkbox-group
                        v-model="checkedFeatures"
                        @change="handleCheckedFeaturesChange(scope)"
                      >
                        <el-checkbox
                          v-for="(item, index) in scope.row.functionList"
                          :key="index"
                          :label="item.functionId"
                          >{{ item.functionName }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </template>
                  </el-table-column>
                  <el-table-column label="全选">
                    <template slot-scope="scope">
                      <el-checkbox
                        @change="handleCheckAllChange(scope)"
                        v-model="scope.row.isChecked"
                        :indeterminate="scope.row.isIndeterminate"
                        :key="scope.$index"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--新增角色-->
    <el-dialog
      v-drag:common
      :visible="dialog.visible"
      title="角色信息"
      width="500px"
      @close="cancelDialog"
    >
      <el-form :rules="dialog.rule" ref="dialog" :model="dialog.data">
        <el-row type="flex" justify="center" class="mt40">
          <el-form-item prop="roleName">
            <el-input
              placeholder="请输入角色名称"
              v-model="dialog.data.roleName"
              :maxlength="30"
              style="width: 400px"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row class="mb20">
          <el-form-item>
            <el-col :span="12" align="center">
              <el-button
                @click="save()"
                type="primary"
                :loading="dialog.loading"
                >确认</el-button
              >
            </el-col>
            <el-col :span="12" align="left">
              <el-button @click="cancelDialog">取消</el-button>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils';
export default {
  name: 'role',
  data() {
    return {
      activeName: 'first',
      rolesList: [],
      roleId: '1',
      customerList: [],
      checked: false,
      // 搜索框
      keyword: '',
      columns: [
        {
          prop: 'userCode',
          label: '用户名'
        },
        {
          prop: 'name',
          label: '姓名'
        },
        {
          prop: 'state',
          label: '状态',
          render: (y, scope) => {
            if (scope.row.state === 0) {
              return <span>启用</span>;
            } else {
              return <span>禁用</span>;
            }
          }
        }
      ],
      dialog: {
        visible: false,
        loading: false,
        rule: {
          roleName: [
            {
              required: true,
              message: '请输入角色名称',
              trigger: 'blur'
            }
            // {
            //   validator: (rule, value, callback) => {
            //     if (value.trim()) {
            //       callback();
            //     } else {
            //       callback(new Error('请输入正确的角色名称'));
            //     }
            //   },
            //   trigger: 'blur'
            // }
          ]
        },
        data: {
          roleId: 0,
          roleName: ''
        }
      },
      authority: [],
      roleTableLoading: false,
      checkedAll: false,
      isIndeterminate: false,
      checkedFeatures: [],
      checkedLength: 0,
      checkedList: [],
      saveChangeLoading: false,
      // 是否展示修改按钮
      isShowButton: false,
      isShowSaveButton: false
    };
  },
  watch: {
    roleId() {
      this.checkedFeatures = [];
      this.$refs.table.load({ page: 1 });
      // this.fetchRoleCustomer({ page: 0 });
      this.fetchAuthority();
    }
    // checkedFeatures(val) {
    // if (val.length === 0) {
    //   return;
    // }
    // this.isShowSaveButton = true;
    // if (val.length !== this.checkedLength) {
    //   this.isShowSaveButton = true;
    // } else {
    //   let isUse = false;
    //   val.forEach(item => {
    //     isUse = this.checkedList.includes(item);
    //   });
    //   if (!isUse) {
    //     this.isShowSaveButton = true;
    //   } else {
    //     this.isShowSaveButton = false;
    //   }
    // }
    // }
  },
  methods: {
    async fetchRole() {
      await this.$fetch('/manage/roleManage/getRoleList', {
        module: 'manage',
        showError: true
      }).then(res => {
        this.rolesList = res.data.defaultParam.map(item => {
          item.roleId = item.roleId.toString();
          item.isShowDelete = false;
          return item;
        });
        this.fetchRoleCustomer({ page: 0 });
        this.fetchAuthority();
      });
    },
    async fetchRoleCustomer(options) {
      const res = await this.$fetch('/manage/roleManage/getRoleUserList', {
        params: {
          roleId: this.roleId,
          pageNo: options.page,
          keyword: this.keyword
        },
        module: 'manage',
        showError: true
      });
      if (!res.data.defaultParam) {
        this.customerList = [];
        return;
      }
      this.customerList = res.data.defaultParam.rows;
      return {
        data: res.data.defaultParam && res.data.defaultParam.rows,
        total: res.data.defaultParam && res.data.defaultParam.total
      };
    },
    async fetchAuthority() {
      this.checkedFeatures = [];
      this.checkedList = [];
      this.roleTableLoading = true;
      await this.$fetch('/manage/roleManage/getFunction', {
        params: {
          roleId: this.roleId
        },
        module: 'manage',
        showError: true
      })
        .then(res => {
          if (!res.data.defaultParam) {
            this.authority = [];
            this.roleTableLoading = false;
            return;
          }
          this.authority = res.data.defaultParam.map(item => {
            let checkedList = [];
            item.functionList.forEach(val => {
              if (val.status === 1) {
                this.checkedFeatures.push(val.functionId);
                checkedList.push(val.functionId);
              }
            });
            this.checkedLength = this.checkedFeatures.length;
            this.checkedList = this.checkedFeatures;
            if (checkedList.length === item.functionList.length) {
              item.isChecked = true;
              item.isIndeterminate = false;
            } else if (
              checkedList.length < item.functionList.length &&
              checkedList.length > 0
            ) {
              item.isChecked = false;
              item.isIndeterminate = true;
            } else {
              item.isChecked = false;
              item.isIndeterminate = false;
            }
            return item;
          });
          this.roleTableLoading = false;
        })
        .catch(e => {
          this.roleTableLoading = false;
          throw e;
        });
    },
    roleSelect(val) {
      this.roleId = val;
    },
    handleClick(val) {
      if (val.name === 'second') {
        this.isShowButton = true;
      }
    },
    addRole() {
      this.dialog.visible = true;
      this.dialog.data.roleName = '';
    },
    delRole(val) {
      this.$confirm('此操作将删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          this.$postForm('/manage/roleManage/delRole', {
            module: 'manage',
            showError: true,
            showSuccess: true,
            data: {
              roleId: val
            }
          }).then(() => {
            // 重新获取机组数据列表
            this.fetchRole();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    changeOrder(roleId, order) {
      this.$postForm('/manage/roleManage/roleUpOrDown', {
        module: 'manage',
        showError: true,
        data: {
          roleId: roleId,
          state: order
        }
      }).then(() => {
        this.fetchRole();
      });
    },
    searchTo() {
      // this.fetchRoleCustomer({ page: 0 });
      this.$refs.table.load({ page: 1 });
    },
    selectStyle(val) {
      let index;
      this.rolesList.forEach((item, i) => {
        if (item.roleId === val.roleId) {
          index = i;
        }
      });
      this.$set(this.rolesList[index], 'isShowDelete', true);
    },
    outStyle(val) {
      this.rolesList.forEach(item => {
        if (item.roleId === val.roleId) {
          item.isShowDelete = false;
        }
      });
    },
    handleCheckAllChange(scope) {
      this.authority.forEach(item => {
        if (scope.row.groupId === item.groupId) {
          if (scope.row.isChecked) {
            scope.row.functionList.forEach(val => {
              if (!this.checkedFeatures.includes(val.functionId)) {
                this.checkedFeatures.push(val.functionId);
              }
            });
            scope.row.isIndeterminate = false;
          } else {
            scope.row.functionList.forEach(val => {
              val.status = 0;
              this.checkedFeatures.splice(
                this.checkedFeatures.indexOf(val.functionId),
                1
              );
            });
          }
        }
      });
      this.isIndeterminate = false;
    },
    handleCheckedFeaturesChange(scope) {
      let newCheckedFeatures = [];
      this.checkedFeatures.forEach(item => {
        for (let i = 0; i < scope.row.functionList.length; i++) {
          if (item === scope.row.functionList[i].functionId) {
            newCheckedFeatures.push(item);
          }
        }
      });
      let checkedCount = newCheckedFeatures.length;
      let checkAll =
        checkedCount === this.authority[scope.$index].functionList.length;
      let isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.authority[scope.$index].functionList.length;
      let { ...newObj } = scope.row;
      newObj.isIndeterminate = isIndeterminate;
      if (checkedCount >= 0) {
        newObj.isChecked = checkAll ? true : false;
      }
      this.$set(this.authority, scope.$index, newObj);
    },
    cancelDialog() {
      this.dialog.visible = false;
      this.dialog.loading = false;
      this.dialog.data.roleId = 0;
      this.dialog.data.roleName = '';
      if (this.$refs.dialog) {
        this.$refs.dialog.clearValidate();
      }
    },
    editRole(val) {
      if (val.roleId == 1) {
        this.$message({
          type: 'info',
          message: '系统管理员不可编辑'
        });
        return false;
      }
      this.dialog.visible = true;
      this.dialog.data.roleId = val.roleId;
      this.dialog.data.roleName = val.roleName;
    },
    save() {
      this.$refs.dialog.validate().then(() => {
        this.dialog.loading = true;
        let url = `/manage/roleManage/saveRole?`;
        let params = `apiKey=${getToken()}&roleId=${
          this.dialog.data.roleId
        }&roleName=${this.dialog.data.roleName}`;
        url = url + params;
        // 编辑用户
        this.$fetch
          .post({
            url,
            module: 'manage',
            showError: true,
            showSuccess: true
          })
          .then(() => {
            this.dialog.loading = false;
            this.dialog.visible = false;
            return this.fetchRole();
          })
          .catch(() => {
            this.dialog.loading = false;
          });
      });
    },
    saveChange() {
      if (this.roleId == 1) {
        this.$message({
          type: 'info',
          message: '系统管理员-权限配置不能进行操作'
        });
        return false;
      }
      this.saveChangeLoading = true;
      let url = `/manage/roleManage/saveRolerFunction?apiKey=${getToken()}&roleId=${
        this.roleId
      }`;
      let dataList = [];
      this.authority.forEach(arr => {
        for (let i = 0; i < arr.functionList.length; i++) {
          if (this.checkedFeatures.includes(arr.functionList[i].functionId)) {
            dataList.push({
              functionId: arr.functionList[i].functionId,
              roleId: this.roleId,
              status: 1
            });
          } else {
            dataList.push({
              functionId: arr.functionList[i].functionId,
              roleId: this.roleId,
              status: 0
            });
          }
        }
      });
      this.$fetch
        .post({
          url,
          data: {
            roleFunctionList: dataList
          },
          methods: 'posts',
          module: 'manage',
          showError: true,
          showSuccess: true
        })
        .then(() => {
          this.saveChangeLoading = false;
          return this.fetchRole();
        })
        .catch(() => {
          this.saveChangeLoading = false;
        });
    }
  },
  mounted() {
    this.fetchRole();
  }
};
</script>

<style lang="less" scoped>
.container {
  /deep/.el-table__empty-block {
    background-color: #fff;
  }
  height: 100%;
  .content {
    height: calc(100% - 34px);
    .e-box {
      height: 100%;
      .e-co {
        height: 100%;
        border-right: 1px solid #d5dae2;
        /*.middle-title {
          font-size: 26px;
          font-weight: bold;
          line-height: 30px;
          display: block;
        }*/
        .middle-add {
          line-height: 30px;
          margin-right: 5px;
        }
        /deep/.el-menu-item.is-active {
          background-color: #f5f7fa;
        }
      }
      .search-box {
        margin: 10px 0;
        .input-with-select {
          width: 400px;
        }
      }
    }
  }
  .checked-box {
    /deep/.el-button {
      position: absolute;
      right: 20px;
      z-index: 2000;
    }
  }
  a {
    text-decoration: none;
    i {
      font-size: 16px;
      margin-right: 0;
      padding-bottom: 3px;
      color: rgb(250, 156, 33);
    }
  }

  /deep/.el-table {
    th .el-checkbox {
      display: none;
    }
  }
}
</style>
